import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { animate, motion, useMotionValue, useTransform } from 'framer-motion';
import { useEffect } from 'react';
export const AnimatedCounter = ({ value, suffix = '', className = '' }) => {
    const count = useMotionValue(0);
    const rounded = useTransform(count, (latest) => Math.round(latest));
    useEffect(() => {
        const controls = animate(count, value, { duration: 1.6, ease: 'easeOut' });
        return () => controls.stop();
    }, [count, value]);
    return (_jsxs(motion.span, { className: className, children: [_jsx(motion.span, { children: rounded }), suffix] }));
};
